import React from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "layouts/DashboardLayout";
import MainLayout from "layouts/MainLayout";
import NotFoundView from "views/errors/NotFoundView";
import { Solicitud } from "views/Solicitudes";
import { Indicadores } from "views/Indicadores";
import { Panelsol } from "views/Panelsol";
import { Panel } from "views/Panel";
import Usuario from "views/Catalogo/Usuario";
import Modulo from "views/Catalogo/Modulo";
import Grupo from "views/Catalogo/Grupo";
import { Reportes } from "views/Reportes";
import { ModAlcance } from "views/Solicitudes/Propuesta/MAlcance";
import { Paneltareas } from "views/Paneltareas";
import LoginView from "views/auth/LoginView";
//import {Progreso} from 'views/Progreso';
import "./styles.css";
import AvanceSolicitud from "views/AvanceSolicitud";
import TareasXrequerimientos from "views/TareasXrequerimientos";
import AvanceIntegrantes from "views/AvanceIntegrantes";
import { rectSortingStrategy } from "@dnd-kit/sortable";
import Tablero from "views/Tablero";
import Pruebas from "views/PruebaDnd";
import IndexView from "views/MainView/IndexView";

const elements = {
  inicio: IndexView,
  ctlPnlsol: Solicitud,
  ctlGrp: Grupo,
  ctlUsrs: Usuario,
  ctlModulos: Modulo,
  indicador: Indicadores,
  psolicitud: Panelsol,
  panel: Panel,
  reportes: Reportes,
  malcance: ModAlcance,
  ptareas: Paneltareas,
  AvncSlct: AvanceSolicitud,
  trsXrqrm: TareasXrequerimientos,
  avncIntrnt: AvanceIntegrantes,
  pruebapag: Pruebas,
  tableroSeg: Tablero,
  // progreso:Progreso
};
// /catalogo/centroCosto
const routes = (rutasUsuario) => [
  {
    path: "/",
    element: (
      <DashboardLayout rutas={rutasUsuario.rutas} usuario={rutasUsuario.info} />
    ),
    children: [
      ...rutasUsuario.rutas.map((vst) => {
        const Componente = elements[vst.idpagina];
        return {
          path:
            vst.raiz == 0
              ? (vst.rutaPadre ? vst.rutaPadre : "") + vst.ruta
              : "",
          // path: (vst.rutaPadre?vst.rutaPadre:'')+vst.ruta,
          element:
            vst.rutaPadre == "Tablero" ? (
              <Tablero
                itemCount={5}
                key={vst.idtablero}
                strategy={rectSortingStrategy}
                horizontal
                idtablero={vst.idtablero}
                nombreTablero={vst.npagina}
                permisos={vst.permisos}
                usuario={rutasUsuario.info}
                idjerarquia={vst.idjerarquia}
                idtipo={vst.idtipo}
              />
            ) : Componente ? (
              <Componente
                permisos={vst.permisos}
                usuario={rutasUsuario.info}
                idtablero={vst?.idtablero}
                idtipo={vst?.idtipo}
                nombreTablero={vst.npagina}
              />
            ) : (
              <Navigate to="/404" />
            ),
        };
      }),
      { path: "solicitud", element: <Solicitud /> },
      { path: "404", element: <NotFoundView /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
];

export default routes;
/*
{
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account', element: <AccountView /> },
      { path: 'dashboard', element: <DashboardView /> },
      { path: 'clientes', element: <Clientes /> },
      { path: 'lecturas', element: <Lecturas /> },
      { path: 'conceptos', element: <Conceptos /> },
      { path: 'tarifas', element: <TarifaView /> },
      { path: 'contratacion', element: <Contratacion /> },
      { path: 'cobranza', element: <Cobranza /> },
      { path: 'info_pagos', element: <Info_Pagos /> },
      { path: '*', element: <Navigate to="/404" /> },


      { path: '*', element: <Navigate to="/404" /> }
    ]
  },*/
